var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("h1", [_vm._v(_vm._s(_vm.$t("tripPolicy.title")))]),
      _c("DelegationInfoMenu"),
      _c(
        "v-row",
        [
          _c("h2", [_vm._v(_vm._s(_vm.title))]),
          _c("v-spacer"),
          _vm.canEdit
            ? _c(
                "v-btn",
                {
                  staticClass: "accent",
                  attrs: { to: "/settings/custom-webpage" }
                },
                [
                  _vm._v(_vm._s(_vm.$t("global.edit")) + " "),
                  _c("v-icon", [_vm._v("border_color")])
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "ql-container ql-snow",
          staticStyle: { border: "none" }
        },
        [
          _c("div", {
            staticClass: "ql-editor",
            domProps: { innerHTML: _vm._s(_vm.html) }
          })
        ]
      ),
      _c("multiple-file-download", {
        attrs: { files: _vm.files },
        on: {
          download: function(fileId) {
            return _vm.download(fileId)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }